import { digitsOnlyPhone, normalizeIndianMobileDigits } from '../shared/phoneUtils';

const DEFAULT_COUNTRY_CODE = '91';

export function staffCanWhatsAppCandidate(user) {
  const role = user?.role;
  return role === 'admin' || role === 'recruiter';
}

export const CANDIDATE_PHONE_COLUMN_KEYS = new Set([
  'phone',
  'mobile',
  'candidatePhone',
  'displayPhone'
]);

export function phoneDigitsForWhatsApp(phone, countryCode = DEFAULT_COUNTRY_CODE) {
  const normalized = normalizeIndianMobileDigits(phone);
  if (normalized.length === 10) {
    return `${countryCode}${normalized}`;
  }
  const digits = digitsOnlyPhone(phone);
  if (digits.length >= 10 && digits.length <= 15) return digits;
  return '';
}

export function buildWhatsAppUrl(phone, { countryCode = DEFAULT_COUNTRY_CODE, text } = {}) {
  const digits = phoneDigitsForWhatsApp(phone, countryCode);
  if (!digits) return '';
  const base = `https://wa.me/${digits}`;
  if (text?.trim()) {
    return `${base}?text=${encodeURIComponent(text.trim())}`;
  }
  return base;
}
